import React, { useState, useEffect } from 'react';
import './index.css';
import {
  Modal,
  ModalHeader,
  ModalHeaderTitle,
  ModalBody,
  TextInput,
  Select,
  Fieldset,
  Field,
  FieldBody,
  Button,
  Alert,
  CheckIcon,
  FieldLabel,
} from '@emorg-prd/react-standard';
import Site from '../../../../api/Site';
import OperationStatus from '../../../../api/OperationStatus';
import ITSiteCode from '../../../../api/ITSiteCode';
import SourceSystem from '../../../../api/SourceSystem';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import PrimaryUseType from '../../../../api/PrimaryUseType';
import { SourceSystemValidationService as SourceSystemValidation } from '../../../../services/sourceSystemValidationService';

export function UpdateSite(props) {
  let {
    siteList,
    setSiteList,
    selectedSite,
    siteName,
    siteCountry,
    siteCode,
    siteOperationStatus,
    sitePrimaryUseType,
    sitePrimaryUseTypeId,
    siteOperationStatusId,
    siteOperationStatusIsActive,
    sitePrimaryUseTypeIsActive,
    itSiteCodeList,
    siteSourceLinkList,
    onChange,
    isAuthorized,
    handlePageError,
    showLoadingSpinner,
    closeWindow,
  } = props;

  const [operationStatusDropdown, setOperationStatusDropdown] = useState([]);
  const [itSiteCodeDropdown, setITSiteCodeDropdown] = useState([]);
  const [siteSourceSystemNameDropdown, setSiteSourceSystemNameDropdown] = useState([]);
  const [siteSourceSystemTypeDropdown, setSiteSourceSystemTypeDropdown] = useState([]);
  const [primaryUseTypeDropdown, setPrimaryUseTypeDropdown] = useState([]);
  const [state, setState] = useState({
    showSuccessAlert: false,
    showFailAlert: false,
    alertMessage: '',
  });

  useEffect(() => {
    PrimaryUseType.getAll().then((res) => {
      primaryUseTypeDataFilter(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    OperationStatus.getAll().then((res) => {
      res.sort((a, b) => a.displayOrder - b.displayOrder);
      setOperationStatusDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    ITSiteCode.getAll().then((res) => {
      setITSiteCodeDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystem.GetSiteSourceSystems().then((res) => {
      setSiteSourceSystemNameDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystemIdType.getAll().then((res) => {
      setSiteSourceSystemTypeDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
  }, []);

  useEffect(() => {
    populateSite(selectedSite);
  }, [selectedSite]);

  useEffect(() => {
    if (state.showSuccessAlert === true) {
      Site.getAll().then((res) => {
        setSiteList(res);
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
  }, [state]);

  const resetSiteState = () => {
    closeWindow();
    setState({ showSuccessAlert: false, showFailAlert: false });
  };

  const saveSiteUpdate = (event) => {
    const updateSiteObject = new Site({
      siteId: selectedSite,
      siteCode: siteCode,
      siteName: siteName,
      operationStatusId: siteOperationStatusId,
      primaryUseTypeId: sitePrimaryUseTypeId,
      itSiteCodeRelate: itSiteCodeList,
      siteSourceSystemRelate: siteSourceLinkList,
    });
    showLoadingSpinner(true);
    Site.update(updateSiteObject).then((res) => {
      if (res.data.isSuccess === true) {
        setState({ showSuccessAlert: true, alertMessage: res.data.message });
      } else {
        setState({ showFailAlert: true, alertMessage: res.data.message });
      }
      showLoadingSpinner(false);
    }).catch((error) => {
      handlePageError(error.message);
    });
  };

  const primaryUseTypeDataFilter = (primaryUseTypes) => {
    let primaryUseTypeOptions = primaryUseTypes.filter((primaryUse) => {
      if (primaryUse.isAssignable.trim().toLowerCase() === 's') {
        return primaryUse;
      } else {
        return null;
      }
    });
    setPrimaryUseTypeDropdown(primaryUseTypeOptions);
  };

  const renderOperationStatusSelect = (operationStatus) => {
    return (
      <option
        id={operationStatus.operationStatusId}
        key={operationStatus.operationStatusId}
        value={operationStatus.operationStatusName}
        hidden={!operationStatus.isActive}
      >
        {operationStatus.operationStatusName}
      </option>
    );
  };

  const renderITSiteCodeDropdown = (itSiteCode) => {
    return (
      <option
        id={itSiteCode.itSiteCodeId}
        key={itSiteCode.itSiteCodeId}
        value={itSiteCode.itSiteCode}
      >
        {itSiteCode.itSiteCode}: {itSiteCode.itSiteCodeDesc}
      </option>
    );
  };

  const renderSourceSystemSelect = (sourceSystem) => {
    return (
      <option
        id={sourceSystem.sourceSystemId}
        key={sourceSystem.sourceSystemId}
        value={sourceSystem.sourceSystemName}
        hidden={!sourceSystem.sourceSystemIsActive}
      >
        {sourceSystem.sourceSystemName}
      </option>
    );
  };

  const renderSourceSystemTypeSelect = (type) => {
    return (
      <option
        id={type.sourceSystemIdTypeId}
        key={type.sourceSystemIdTypeId}
        value={type.sourceSystemIdTypeName}
        hidden={!type.sourceSystemIdTypeIsActive}
      >
        {type.sourceSystemIdTypeName}
      </option>
    );
  };

  const handleOperationStatusSelect = (event) => {
    onChange('siteOperationStatus', event.target.value);
    onChange('siteOperationStatusId', event.target.options[event.target.selectedIndex].id);
    onChange('siteOperationStatusIsActive', true);
  };

  const handlePrimaryUseTypeSelect = (event) => {
    onChange('sitePrimaryUseType', event.target.value);
    onChange('sitePrimaryUseTypeId', event.target.options[event.target.selectedIndex].id);
    onChange('sitePrimaryUseTypeIsActive', true);
  };

  const handleITSiteCodeSelect = (index, event) => {
    const values = [...itSiteCodeList];
    values[parseInt(index)].itSiteCode = event.target.value;
    values[parseInt(index)].itSiteCodeId = event.target.options[event.target.selectedIndex].id;
    onChange('itSiteCodeList', values);
  };

  const addITSiteCode = () => {
    const values = [...itSiteCodeList];
    values.push({
      //newCode: false,
      //itSiteCodeId: '',
      itSiteCode: '',
      siteId: selectedSite,
    });
    onChange('itSiteCodeList', values);
  };

  const removeITSiteCodeField = (index) => {
    const values = [...itSiteCodeList];
    if (values.length > 1) {
      values.splice(index, 1);
      onChange('itSiteCodeList', values);
    } else {
      alert('Site must have one IT Site Code.');
    }
  };

  const handleSourceSystemChange = (input, index, event) => {
    const values = [...siteSourceLinkList];
    const currentSource = values[parseInt(index)];
    switch (input) {
      case 'name':
        currentSource.sourceSystemName = event.target.value;
        currentSource.sourceSystemId = event.target.options[event.target.selectedIndex].id;
        currentSource.sourceSystemIdTypeName = '';
        currentSource.sourceSystemIdTypeId = '';
        currentSource.sourceSystemReferenceId = '';
        break;
      case 'type':
        currentSource.sourceSystemIdTypeName = event.target.value;
        currentSource.sourceSystemIdTypeId = event.target.options[event.target.selectedIndex].id;
        currentSource.isSourceSystemValid = SourceSystemValidation.isNoValidationSourceSystem(currentSource);
        break;
      case 'id':
        if (
          SourceSystemValidation.isOriginalSourceSystem(event.target.value, currentSource)
          || SourceSystemValidation.isNoValidationSourceSystem(currentSource)
        ) {
          currentSource.isSourceSystemValid = true;
        }
        else {
          currentSource.isSourceSystemValid = false;
        }
        currentSource.sourceSystemReferenceId = event.target.value;
        break;
      default:
        break;
    }
    onChange('siteSourceLinkList', values);
  };

  const addSourceSystem = () => {
    const siteSourceLinkListCopy = [...siteSourceLinkList];
    siteSourceLinkListCopy.push({
      sourceSystemId: '',
      sourceSystemName: '',
      sourceSystemIsActive: true,
      sourceSystemIdTypeId: '',
      sourceSystemIdTypeName: '',
      sourceSystemIdTypeIsActive: true,
      sourceSystemReferenceId: '',
      siteId: selectedSite,
      isSourceSystemValid: false,
      isLoading: false,
      validationErrorMessage: ''
    });
    onChange('siteSourceLinkList', siteSourceLinkListCopy);
  };
  const getAvailableSourceSystemTypes = (currentIndex, sourceSystemId) => {
  const selectedTypeIds = siteSourceLinkList
    .filter(
      (item, index) =>
        index !== currentIndex &&
        String(item.sourceSystemId) === String(sourceSystemId)
    )
    .map(item => String(item.sourceSystemIdTypeId))
    .filter(Boolean);

  return siteSourceSystemTypeDropdown.filter(
    type =>
      String(type.sourceSystemId) === String(sourceSystemId) &&
      (
        !selectedTypeIds.includes(String(type.sourceSystemIdTypeId)) ||
        String(type.sourceSystemIdTypeId) ===
          String(siteSourceLinkList[currentIndex]?.sourceSystemIdTypeId)
      )
  );
};
  const removeSourceSystem = (index) => {
    const siteSourceLinkListCopy = [...siteSourceLinkList];
    if (siteSourceLinkListCopy.length > 1) {
      siteSourceLinkListCopy.splice(index, 1);
      onChange('siteSourceLinkList', siteSourceLinkListCopy);
    } else {
      alert('Site must have one Source System');
    }
  };

  async function validateSourceSystemReferenceId(index) {
    let sourceSystemLinkListCopy = [...siteSourceLinkList];
    let sourceSystemLink = sourceSystemLinkListCopy[parseInt(index)];

    sourceSystemLink.validationErrorMessage = '';
    sourceSystemLink.isLoading = true;
    onChange('siteSourceLinkList', sourceSystemLinkListCopy);

    sourceSystemLink = await SourceSystemValidation.validateSiteSourceSystem(sourceSystemLink);
    
    onChange('siteSourceLinkList', sourceSystemLinkListCopy);
  }

  const populateSite = (value) => {
    clearFormValues();
    onChange('siteId', value);
    let currentSiteId = value;
    const currentSiteObj = siteList.find((site) => site.siteId === currentSiteId);
    if (currentSiteObj) {
      const currentOpStatus = operationStatusDropdown.find(
        (opStatus) => opStatus.operationStatusId === currentSiteObj.operationStatusId
      );
      if (currentSiteObj.primaryUseTypeId) {
        const currentPrimaryUseType = primaryUseTypeDropdown.find(
          (primaryUse) => primaryUse.primaryUseTypeId === currentSiteObj.primaryUseTypeId
        );
        onChange('sitePrimaryUseType', currentPrimaryUseType.primaryUseTypeName);
        onChange('sitePrimaryUseTypeId', currentPrimaryUseType.primaryUseTypeId);
        onChange('sitePrimaryUseTypeIsActive', currentPrimaryUseType.isActive);
      }

      if (currentSiteObj.itSiteCodeRelate.length) {
        currentSiteObj.itSiteCodeRelate.forEach((element, index) => {
          let elementValue = {
            itSiteCodeRelateId: element.itSiteCodeRelateId,
            itSiteCode: element.itSiteCode?.itSiteCode,
            siteId: element.siteId,
            itSiteCodeId: element.itSiteCodeId,
            itSiteCodeDesc: element.itSiteCode?.itSiteCodeDesc,
          };
          itSiteCodeList.push(elementValue);
        });
      }

      if (currentSiteObj.siteSourceSystemRelate.length) {
        currentSiteObj.siteSourceSystemRelate.forEach((element, index) => {
          let elementSourceSystem = {
            siteSourceSystemId: element.siteSourceSystemId,
            sourceSystemIdTypeId: element.sourceSystemIdTypeId,
            originalSourceSystemIdTypeId: element.sourceSystemIdTypeId,
            sourceSystemId: element.sourceSystem?.sourceSystemId,
            siteId: element.siteId,
            sourceSystemReferenceId: element.sourceSystemReferenceId,
            originalSourceSystemReferenceId: element.sourceSystemReferenceId,
            sourceSystemName: element.sourceSystem?.sourceSystemName,
            sourceSystemIsActive: element.sourceSystem?.isActive.toLowerCase() === 'y' ? true : false,
            sourceSystemIdTypeName: element.sourceSystemIdType?.sourceSystemIdTypeName,
            sourceSystemIdTypeIsActive: element.sourceSystemIdType?.isActive,
            isSourceSystemValid: true,
            isLoading: false,
            validationErrorMessage: ''
          };
          siteSourceLinkList.push(elementSourceSystem);
        });
      }

      onChange('siteName', currentSiteObj.siteName);
      onChange('siteCountry', currentSiteObj.country?.countryName);
      onChange('siteCode', currentSiteObj.siteCode);
      onChange('siteOperationStatus', currentOpStatus.operationStatusName);
      onChange('siteOperationStatusId', currentSiteObj.operationStatusId);
      onChange('siteOperationStatusIsActive', currentOpStatus.isActive);
    }
  };

  const clearFormValues = () => {
    onChange('siteCode', '');
    onChange('siteCountry', '');
    onChange('siteOperationStatus', '');
    onChange('siteOperationStatusId', '');
    onChange('sitePrimaryUseTypeId', '');
    onChange('siteName', '');
    itSiteCodeList.splice(0, itSiteCodeList.length);
    siteSourceLinkList.splice(0, siteSourceLinkList.length);
  };
  return (
    <div>
      <Modal show={props.updateWindow} onHide={resetSiteState} className='update-site'>
        <ModalHeader>
          <ModalHeaderTitle>Update {siteName}</ModalHeaderTitle>
        </ModalHeader>
        <div>
          {!isAuthorized && (
            <Alert variant='error' className='site-auth-alert'>
              User is Not Authorized to Edit Sites
            </Alert>
          )}
          {state.showSuccessAlert && (
            <Alert variant='success' className='site-alert'>
              {state.alertMessage}
            </Alert>
          )}
          {state.showFailAlert && (
            <Alert variant='error' className='site-alert'>
              {state.alertMessage}
            </Alert>
          )}
        </div>
        <ModalBody className='scrollBar'>
          <Fieldset style={{ paddingTop: '0px' }}>
            <TextInput
              className='text-input_site-update'
              label='Site Name'
              value={siteName}
              onChange={(e) => onChange('siteName', e.target.value)}
            />
            <TextInput
              className='text-input_site-update'
              label='Site Country'
              value={siteCountry}
              readOnly
            />
            <TextInput
              className='text-input_site-update'
              label='Site Code'
              value={siteCode}
              onChange={(e) => onChange('siteCode', e.target.value)}
              error={
                siteCode.length < 1 || siteCode.length > 20
              }
              note={
                siteCode.length > 20
                ? 'Maximum length of 20 characters'
                : ''
              }
            />
            <div class="operation-select">
              <div class="em-c-field">
                <label class="em-c-field__label">Primary Use</label>
                <Select
                  selectProps={{
                    className: 'operation-select'
                  }}
                  style={{ backgroundColor: sitePrimaryUseTypeIsActive ? 'white' : 'lightgray' }}
                  value={sitePrimaryUseType}
                  onChange={(e) => handlePrimaryUseTypeSelect(e)}
                >
                  <option value=''>Select</option>
                  {primaryUseTypeDropdown.map((primaryUse) => {
                    return (
                      <option
                        key={primaryUse.primaryUseTypeId}
                        id={primaryUse.primaryUseTypeId}
                        value={primaryUse.primaryUseTypeName}
                        hidden={!primaryUse.isActive}
                      >
                        {primaryUse.primaryUseTypeName}
                      </option>
                    );
                  })}
                </Select>
              </div>
            </div>
            <div class="operation-select">
              <div class="em-c-field">
                <label class="em-c-field__label">Operation Status</label>
                <Select
                  selectProps={{
                    className: 'operation-select'
                  }}
                  style={{ backgroundColor: siteOperationStatusIsActive ? 'white' : 'lightgray' }}
                  value={siteOperationStatus}
                  onChange={(e) => handleOperationStatusSelect(e)}
                >
                  <option value=''>Select</option>
                  {operationStatusDropdown.map(renderOperationStatusSelect)}
                </Select>
              </div>
            </div>
          </Fieldset>

          <Fieldset>
            {itSiteCodeList.map((siteCode, index) => (
              <Field key={`${siteCode}~${index}`}>
                <FieldLabel></FieldLabel>
                <FieldBody>
                  <div className='input-row' style={{ display: 'inline-flex' }}>
                    <Select
                      selectProps={{
                        className: 'it-site-code',
                      }}
                      label='IT Site Code'
                      value={siteCode.itSiteCode}
                      onChange={(e) => handleITSiteCodeSelect(index, e)}
                    >
                      <option value=''>Select</option>
                      {itSiteCodeDropdown.map(renderITSiteCodeDropdown)}
                    </Select>
                    <Button
                      style={{ paddingTop: '45px', paddingLeft: '35px' }}
                      className='small-margin'
                      variant='tertiary'
                      size='small'
                      onClick={() => removeITSiteCodeField(index)}
                    >
                      × Remove IT Site Code
                    </Button>
                  </div>
                </FieldBody>
              </Field>
            ))}
            <Button
              className='small-margin'
              variant='tertiary'
              size='small'
              onClick={addITSiteCode}
            >
              + Add IT Site Code
            </Button>
          </Fieldset>

          <Fieldset>
            {siteSourceLinkList.map((siteSourceSystem, index) => (
              <div key={`${siteSourceSystem}~${index}`}>
                <FieldBody>
                  <Alert
                    variant='error'
                    style={{
                      marginBottom: '15px',
                      display:
                      siteSourceSystem.validationErrorMessage != ''
                        ? 'flex' : 'none',
                    }}
                  >
                    {siteSourceSystem.validationErrorMessage}
                  </Alert>
                  <div className='input-row' style={{ display: 'inline-flex' }}>
                    <Select
                      style={{ paddingRight: '10px' }}
                      selectProps={{
                        className: 'source-system_site-update',
                      }}
                      label='Source System'
                      disabled={!siteSourceSystem.sourceSystemIsActive}
                      value={siteSourceSystem.sourceSystemName}
                      onChange={(e) => handleSourceSystemChange('name', index, e)}
                    >
                      <option value=''>Select</option>
                      {siteSourceSystemNameDropdown.map(renderSourceSystemSelect)}
                    </Select>
                    <Select
                      style={{ paddingRight: '10px' }}
                      selectProps={{
                        className: 'source-system_site-update',
                      }}
                      label='Source System Type'
                      disabled={!siteSourceSystem.sourceSystemIsActive}
                      value={siteSourceSystem.sourceSystemIdTypeName}
                      onChange={(e) => handleSourceSystemChange('type', index, e)}
                    >
                      <option value=''>Select</option>
                      {/* Filtering the list of possible Source System Types based on the system selected e.g. ACSSiteCode when Genetec is selected */}
                      {/* {siteSourceSystemTypeDropdown
                        .filter((type) =>
                          type.sourceSystemId == siteSourceSystem.sourceSystemId
                        )
                        .map(renderSourceSystemTypeSelect)} */}
                        {getAvailableSourceSystemTypes(
                           index,
                           siteSourceSystem.sourceSystemId
                        ).map(renderSourceSystemTypeSelect)}
                    </Select>

                    <form className='-em-c-search-form'>
                      <div className='em-c-search__body'>
                        <TextInput
                          className='site-dynamic-field'
                          label='Source System Reference Id'
                          disabled={!siteSourceSystem.sourceSystemIsActive}
                          placeholder=''
                          style={{ paddingLeft: '15px', width: '300px' }}
                          value={siteSourceSystem.sourceSystemReferenceId}
                          error={
                            siteSourceSystem.sourceSystemReferenceId === '' ||
                            !siteSourceSystem.isSourceSystemValid
                          }
                          onChange={(e) => handleSourceSystemChange('id', index, e)}
                        />
                        <Button
                          style={{
                            marginTop: '26.3px',
                            display:
                              siteSourceSystem.sourceSystemIdTypeName &&
                              siteSourceSystem.sourceSystemReferenceId &&
                              !SourceSystemValidation.isNoValidationSourceSystem(siteSourceSystem) &&
                              !siteSourceSystem.isLoading &&
                              siteSourceSystem.sourceSystemIsActive
                                ? 'block' : 'none'
                          }}
                          className={
                            !siteSourceSystem.isSourceSystemValid
                              ? 'small-margin validation-button red-outline'
                              : 'small-margin validation-button grey-outline'
                          }
                          variant='secondary'
                          size='medium'
                          error={
                            siteSourceSystem.sourceSystemIdTypeName &&
                            !siteSourceSystem.isSourceSystemValid
                          }
                          onClick={(e) => {
                            if (
                              siteSourceSystem.sourceSystemIdTypeId &&
                              siteSourceSystem.sourceSystemReferenceId &&
                              siteSourceSystem.sourceSystemName
                            ) {
                              validateSourceSystemReferenceId(
                                index,
                                siteCountry
                              )
                            }}
                          }
                        >
                          {siteSourceSystem.isSourceSystemValid ? '' : 'Validate'}
                          <CheckIcon
                            style={{
                              display:
                                siteSourceSystem.isSourceSystemValid ? 'block' : 'none'
                            }}
                          />
                        </Button>
                        <Button
                          style={{
                            marginTop: '26.3px',
                            display:
                              siteSourceSystem.sourceSystemIdTypeName &&
                              siteSourceSystem.isLoading
                                ? 'block' : 'none',
                          }}
                          className='small-margin validation-button'
                          loading
                          size='medium'
                        >
                          Loading
                        </Button>
                      </div>
                    </form>

                    <Button
                      style={{ paddingTop: '45px', paddingLeft: '35px' }}
                      className='small-margin'
                      variant='tertiary'
                      size='small'
                      onClick={() => removeSourceSystem(index)}
                    >
                      × Remove Site Source Link
                    </Button>
                  </div>
                </FieldBody>
              </div>
            ))}
            <Button
              className='small-margin'
              variant='tertiary'
              size='small'
              onClick={addSourceSystem}
            >
              + Add Site Source Link
            </Button>
          </Fieldset>

          <Button
            style={{ marginRight: '10px', padding: '10px 20px 10px 20px' }}
            className='small-margin'
            variant='secondary'
            onClick={resetSiteState}
          >
            Cancel
          </Button>
          <Button
            className='small-margin'
            variant='primary'
            onClick={(e) => saveSiteUpdate(e)}
            disabled={
              !isAuthorized ||
              siteSourceLinkList.some(sourceSystem => sourceSystem.isSourceSystemValid === false)
            }
          >
            Save
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default UpdateSite;
